// 盘点表状态
export default [
  {
      "code": "CU009",
      "name": "美团"
  },
  {
      "code": "CU010",
      "name": "饿了么"
  },
  {
      "code": "CU011",
      "name": "京东到家"
  },
  {
      "code": "CU008",
      "name": "米度优选"
  },
  {
      "code": "CU019",
      "name": "吴勇"
  },
  {
      "code": "CU001",
      "name": "巨莱昂时代（福州）科技有限公司"
  },
  {
      "code": "CU005",
      "name": "巨莱昂（福州）供应链管理有限公司"
  },
  {
      "code": "CU006",
      "name": "巨莱昂（福州）品牌管理有限公司"
  },
  {
      "code": "CU003",
      "name": "福州起瑞科技有限公司"
  },
  {
      "code": "CU007",
      "name": "上海丰若奇产品模型设计制作有限公司"
  },
  {
      "code": "CU004",
      "name": "厦门米度优选科技有限公司"
  },
  {
      "code": "CU002",
      "name": "福州巨莱昂科技有限公司"
  },
  {
      "code": "CU025",
      "name": "陈舒怡"
  },
  {
      "code": "CU026",
      "name": "陈晞莹"
  },
  {
      "code": "CU027",
      "name": "中佰(海口)企业管理咨询有限公司"
  },
  {
      "code": "CU028",
      "name": "林敦钦"
  },
  {
      "code": "CU029",
      "name": "余诗伟"
  },
  {
      "code": "CU014",
      "name": "岳晓华"
  },
  {
      "code": "CU015",
      "name": "施传松"
  },
  {
      "code": "CU016",
      "name": "翁峰明"
  },
  {
      "code": "CU017",
      "name": "许祥海"
  },
  {
      "code": "CU018",
      "name": "曹建文"
  },
  {
      "code": "CU020",
      "name": "文锦"
  },
  {
      "code": "CU021",
      "name": "吴运琳"
  },
  {
      "code": "CU022",
      "name": "李海"
  },
  {
      "code": "CU023",
      "name": "福州思特源科技有限公司"
  },
  {
      "code": "CU024",
      "name": "陈云"
  },
  {
      "code": "CU030",
      "name": "代运营店群"
  },
  {
      "code": "CU031",
      "name": "朱尧春"
  },
  {
      "code": "CU033",
      "name": "福建熹锐科技有限公司"
  },
  {
      "code": "CU034",
      "name": "成都快购"
  },
  {
      "code": "CU035",
      "name": "杭州华橙网络科技有限公司"
  },
  {
      "code": "CU013",
      "name": "零星客户"
  },
  {
      "code": "CU032",
      "name": "合利宝"
  },
  {
      "code": "CU012",
      "name": "拼多多"
  },
  {
      "code": "CU036",
      "name": "陈桂龙"
  },
  {
      "code": "CU043",
      "name": "小程序商城"
  }
]